import { render } from "./shield-question-icon.vue?vue&type=template&id=21908c94"
import script from "./shield-question-icon.vue?vue&type=script&lang=js"
export * from "./shield-question-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__